module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/avatar-c903075c723719647c16eaa0cdf948bd.png";